import { Directive, HostListener, ElementRef, Input } from "@angular/core";
import { LeftPadPipe } from 'angular-pipes/src/string/left-pad.pipe';
import { TrimPipe } from 'angular-pipes/src/string/trim.pipe';

@Directive({ selector: "[leftpad]" })
export class LeftPadDirective  {

    private el: HTMLInputElement;
    private leftpadpipe: LeftPadPipe;
    private trimPipe: TrimPipe;

    @Input('leftpad') caracter: string;
    @Input('longitud') nrolongitud: number;

    constructor(
        private elementRef: ElementRef

    ) {
        this.el = this.elementRef.nativeElement;
        this.leftpadpipe = new LeftPadPipe();
        this.trimPipe = new TrimPipe();
    }


    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {
        
        let valor = this.trimPipe.transform(value);
        this.el.value = this.leftpadpipe.transform(valor, this.nrolongitud, this.caracter);
    }

}


// WEBPACK FOOTER //
// ./src/app/shared/utils/directives/leftpad.directive.ts